import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-counter',
  templateUrl: './text-counter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextCounterComponent {
  @Input() currentLength?: number;
  @Input() maxLength?: number;

  getRemainingSigns(): number {
    if (this.maxLength) {
      return this.maxLength - this.currentLength ?? this.maxLength;
    }
  }
}
